import { UFModel } from './uf.model';

export class EnderecoSchemaCentrusModel {

  constructor(
    public cdCentrus?: number,
    public cdCep?: string,
    public cdCidadeEnder?: number,
    public cdPaisEnder?: number,
    public dsEMail1?: string,
    public dsEMail2?: string,
    public dtUltAtu?: string,
    public enCompl?: string,
    public enPessoa?: string,
    public noBairro?: string,
    public nrCaixaPostal?: number,
    public nrCelular1?: number,
    public nrCelular2?: number,
    public nrFax1?: number,
    public nrFax2?: number,
    public nrFone1?: number,
    public nrFone2?: number,
    public nrRamalFone1?: number,
    public nrRamalFone2?: number,
    public nrDdd1?: number,
    public nrDdd1Celular?: number,
    public nrDdd2?: number,
    public nrDdd2Celular?: number,
    public sgUfEnder?: string,
    public tpEnPessoa?: number,
  ) {
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/endereco-schema-centrus.model.ts